export default __webpack_public_path__ + "static/media/placeholder.59444505.png";